import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	filtro: {
		data: DateFormat.getDataAtual()
	},
	lista: [],
	listaProducoes: [],
	historicoProducao: [],
	idCargaHistorico: null
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'CARGA_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CARGA_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'CARGA_SET_FILTRO':
			return {
				...state,
				filtro: action.payload
			};

		case 'CARGA_LISTADO':
			return {
				...state,
				lista: action.payload.data
			};

		case 'CARGA_PRODUCAO_LISTADO':
			return {
				...state,
				listaProducoes: action.payload.data
			};

		case 'CARGA_HISTORICO_PRODUCAO_LISTADO':
			return {
				...state,
				idCargaHistorico: action.payload.idCarga,
				historicoProducao: action.payload.lista
			};

		case 'CARGA_HISTORICO_PRODUCAO_LIMPAR':
			return {
				...state,
				idCargaHistorico: null,
				historicoProducao: []
			};

		default:
			return state;
	}
};
